import http from 'util/http'

/**
 * 荣耀殿堂 => 投顾分类列表
 * @param {number} type 对应tab【front前端展示、all所有】
 * @param {string} project 项目【默认soft】
 */
export function getLecturerGloryTabList({
  type = 'front',
  project = 'soft',
}: {
  type?: string
  project?: string
}) {
  return http.get('/newxyrj/public/interest/sort/list', { type, project })
}

/**
 * 荣耀殿堂 => 投顾分类详情
 * @param {number} id tab对应投顾列表【首席投顾->投资顾问】
 * @param {string} project 项目【默认soft】
 */
export function getLecturerGloryTabDetails({
  id,
  project = 'soft',
}: {
  id: number
  project?: string
}) {
  return http.get('/newxyrj/public/interest/data/list', {
    sort_id: id,
    project,
  })
}

/**
 * 专业学习 => 章节列表
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudySection({
  project = 'soft',
}: {
  project?: string
}) {
  return http.get('/newxyrj/public/interest/learn/section/list', { project })
}

/**
 * 专业学习 => 章节题目列表
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudySectionList({
  id,
  project = 'soft',
}: {
  id: string
  project?: string
}) {
  return http.get('/newxyrj/public/interest/learn/course/list', {
    section_id: id,
    project,
  })
}

/**
 * 专业学习 => 考核状态
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudyStatus({
  project = 'soft',
}: {
  project?: string
}) {
  return http.get('/newxyrj/public/interest/assess/status', { project })
}

/**
 * 专业学习 => 当前投顾等级
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudyClass({
  project = 'soft',
}: {
  project?: string
}) {
  return http.get('/newxyrj/public/interest/get/sort_id', { project })
}

/**
 * 专业学习 => 开启考核
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudyOpenAssess({
  project = 'soft',
}: {
  project?: string
}) {
  return http.post('/newxyrj/public/interest/open/assess', { project })
}

/**
 * 专业学习 => 开启章节
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudyOpenAssessSection({
  project = 'soft',
  id,
}: {
  project?: string
  id: number
}) {
  return http.post('/newxyrj/public/interest/open/section', {
    project,
    section_id: id,
  })
}

/**
 * 专业学习 => 投顾晋升消息
 * @param {string} project 项目【默认soft】
 */
export function getLecturerStudyPromoteMsg({
  project = 'soft',
}: {
  project?: string
}) {
  return http.get('/newxyrj/public/interest/promotion/message', { project })
}

/**
 * 考核课程 => 获取视频
 * @param {number} 视频ID
 */
export function getLecturerStudySectionVideo({ id }: { id: number }) {
  return http.get('/newxyrj/public/article/id', { id })
}

/**
 * 考核课程 => 确认学习
 * @param {number} id
 */
export function SubmitLecturerStudyAffirm({ id }: { id: number }) {
  return http.post('/newxyrj/public/interest/course/submit', { course_id: id })
}
